import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import backend from 'i18next-xhr-backend';
import de from 'i18n/locales/de';
import en from 'i18n/locales/en';
// the translations
// (tip move them in a JSON file and import them)
const resources = {
  de,
  en,
  "en-UK":en,
  "en-US":en,
  "de-DE":de,
  "de-AT":de
};

i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: 'en',
    debug:true,
    // supportedLngs: ['en', 'de'],
    nonExplicitSupportedLngs: true, //support language variation
    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: false, // we also don't use namespaces
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources,
    whitelist: ["en","de"],
    /*backend: {
      loadPath: process.env.REACT_APP_BASE_URL + "/v1/locales/translations",
      parse: function(data) {
        console.log("DATA", data);
      },
      init: {
        mode: "no-cors",
        credentials: "include",
        cache: "default"
      }
    },
    cache: {
      enabled: true,
      prefix: "i18next_translations_",
      expirationTime: 24 * 60 * 60 * 1000 //one day
    }*/
  });

export { useTranslation, withTranslation } from 'react-i18next';

export type { TFunction } from 'i18next';

export default i18n;
